export class ProviderImportModel {
  column: string = "";
  counter: number = 0;
  typeDocumentId: number = 0;
  document: string = "";
  digitVerification: number = 0;
  typePersonId: number = 0;
  names: string | null = null;
  lastNames: string | null = null;
  businessName: string = "";
  comercialName: string = "";
  email: string | null = null;
  phone: string = "";
  alterPhone: string | null = null;
  address: string = "";
  departmentCode: string = "";
  cityCode: string = "";
  rateDiscount: number = 0;
  shopping: boolean = false;
  subRent: boolean = false;
  transport: boolean = false;
  currencyCode: string = "";
  expirationDays: number = 0;
  swExpirationDays: boolean = false;

  constructor(column: string,
    counter: number,
    typeDocumentId: number,
    document: string,
    digitVerification: number,
    typePersonId: number,
    names: string | null,
    lastNames: string | null,
    businessName: string,
    comercialName: string,
    email: string | null,
    phone: string,
    alterPhone: string | null,
    address: string,
    departmentCode: string,
    cityCode: string,
    rateDiscount: number,
    shopping: boolean,
    subRent: boolean,
    transport: boolean,
    currencyCode: string,
    expirationDays: number,
    swExpirationDays: boolean
  ) {
    this.column = column;
    this.counter = counter;
    this.typeDocumentId = typeDocumentId;
    this.document = document;
    this.digitVerification = digitVerification;
    this.typePersonId = typePersonId;
    this.names = names;
    this.lastNames = lastNames;
    this.businessName = businessName;
    this.comercialName = comercialName;
    this.address = address;
    this.email = email;
    this.phone = phone;
    this.alterPhone = alterPhone;
    this.departmentCode = departmentCode;
    this.cityCode = cityCode;
    this.rateDiscount = rateDiscount;
    this.shopping = shopping;
    this.subRent = subRent;
    this.transport = transport;
    this.currencyCode = currencyCode;
    this.expirationDays = expirationDays;
    this.swExpirationDays = swExpirationDays;
  }
}